import { FormRadioGroup } from '@pm/forms';
import { type QuestionnaireRadioQuestion as GQLQuestionnaireRadioQuestion } from '@pm/graphql';
import { QuestionnaireMarkdown, SingleSelect } from '@pm/ui';
import { CardText } from '../CardText';
import { QuestionnaireSection } from './QuestionnaireSection';

type QuestionnaireRadioGroupQuestionProps = GQLQuestionnaireRadioQuestion;

export const QuestionnaireRadioGroupQuestion = ({
  id,
  acceptableAnswers = [],
  title,
  description,
}: QuestionnaireRadioGroupQuestionProps) => {
  const radioOptions = acceptableAnswers.map((acceptableAnswer) => {
    const optionParts = acceptableAnswer.label.split(/\n(.*)/s);
    const hasHeaderAndBody = optionParts.length > 1;
    const isFreeTextOption = acceptableAnswer.value === null;

    return {
      header: hasHeaderAndBody ? optionParts[0] : '',
      body: hasHeaderAndBody ? optionParts[1] : optionParts[0],
      value: acceptableAnswer.value ?? '',
      ...(isFreeTextOption && { freeText: {} }),
    };
  });

  const labelId = `${id}-label`;

  return (
    <QuestionnaireSection>
      <div id={labelId}>
        <CardText className="text-grey-900 text-xl">{title}</CardText>
        {description && (
          <CardText>
            <QuestionnaireMarkdown>{description}</QuestionnaireMarkdown>
          </CardText>
        )}
      </div>
      <FormRadioGroup
        name={id}
        aria-labelledby={labelId}
        options={radioOptions}
        RadioComponent={SingleSelect}
      />
    </QuestionnaireSection>
  );
};
